export const buildMapsUrl = ({ lat, lng, direccion, name } = {}) => {
    const latNum = Number(lat);
    const lngNum = Number(lng);

    // Coordenadas válidas
    if (Number.isFinite(latNum) && Number.isFinite(lngNum)) {
        const label = encodeURIComponent(name || direccion || "Ubicación");
        return `https://www.google.com/maps/search/?api=1&query=${latNum},${lngNum}&query_place_id=${label}`;
    }

    // Dirección o nombre
    const q = encodeURIComponent(direccion || name || "");
    if (q) {
        return `https://www.google.com/maps/search/?api=1&query=${q}`;
    }

    // Fallback
    return "https://www.google.com/maps";
};